export const CacheKey = {
    memories: ["memories"],
    favoriteMemories: ["favorite-memories"],
};
